module.exports = __webpack_public_path__ + "static/media/profilepic.c36144d7.png";